import {Observable} from 'rxjs';

export abstract class MediaDownloadService {
    abstract fetchBlob(url: string): Observable<Blob>;
}
